
export const PEOPLE_DIRECTORY = 'people';
export const IMAGE_FIELDS = ['image'];